import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profile: null,
  // The PUT is a full replace, so a save is only safe once a read has landed.
  loaded: false,
  loading: false,
  saving: false,
  uploading: false,
  // Set on a successful save so the form can confirm it without a toast system.
  savedAt: null,
  error: null,
  // field -> message, from a 400's error.details.
  fieldErrors: {},
  forbidden: false,
};

const teamProfileSlice = createSlice({
  name: 'teamProfile',
  initialState,
  reducers: {
    getMyProfileAction: (state) => {
      state.loading = true;
      state.error = null;
      state.forbidden = false;
    },
    saveMyProfileAction: (state) => {
      state.saving = true;
      state.error = null;
      state.fieldErrors = {};
      state.savedAt = null;
    },
    uploadProfilePictureAction: (state) => {
      state.uploading = true;
      state.error = null;
    },
    // Both the read and the save return the same card, so they land in one place.
    myProfileLoaded: (state, action) => {
      state.profile = action.payload;
      state.loaded = true;
      state.loading = false;
      state.saving = false;
      state.error = null;
      state.fieldErrors = {};
    },
    myProfileSaved: (state, action) => {
      state.profile = action.payload.profile;
      state.saving = false;
      state.savedAt = action.payload.savedAt;
      state.fieldErrors = {};
      state.error = null;
    },
    myProfileFailure: (state, action) => {
      const { message, fieldErrors, forbidden } = action.payload;
      state.loading = false;
      state.saving = false;
      state.uploading = false;
      state.error = message;
      state.fieldErrors = fieldErrors || {};
      state.forbidden = Boolean(forbidden);
    },
    pictureUploaded: (state) => {
      state.uploading = false;
    },
    clearProfileFeedback: (state) => {
      state.error = null;
      state.fieldErrors = {};
      state.savedAt = null;
    },
  },
  extraReducers: (builder) => {
    // By type: the tour slice imports myProfileLoaded, so importing it back would cycle.
    builder.addCase('tour/walkthroughCompleted', (state, action) => {
      state.profile = action.payload;
      state.loaded = true;
    });
  },
});

export const {
  getMyProfileAction,
  saveMyProfileAction,
  uploadProfilePictureAction,
  myProfileLoaded,
  myProfileSaved,
  myProfileFailure,
  pictureUploaded,
  clearProfileFeedback,
} = teamProfileSlice.actions;

export { teamProfileSlice };
